import React from 'react';

/**
 * Botão de alternância de tema (claro/escuro)
 *
 * @param {Object} props
 * @param {boolean} props.darkMode - Estado atual do modo escuro
 * @param {Function} props.setDarkMode - Função para alternar o modo
 */
function ThemeToggle({ darkMode, setDarkMode }) {
  return (
    <button
      type="button"
      onClick={() => setDarkMode(!darkMode)}
      className={`fixed bottom-5 right-5 w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 z-50 ${darkMode
        ? 'bg-slate-800/80 border border-slate-600/15 text-yellow-400 hover:bg-slate-700/80'
        : 'bg-white/80 border border-slate-200 text-slate-600 hover:bg-slate-100/80 shadow-lg'
        }`}
      title={darkMode ? 'Ativar modo claro' : 'Ativar modo escuro'}
    >
      {darkMode ? (
        // Ícone do Sol (modo claro)
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      ) : (
        // Ícone da Lua (modo escuro)
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      )}
    </button>
  );
}

export default ThemeToggle;
